import { Button, Tooltip, Popconfirm } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import { useMarkInvoiceAsPaid } from '../../hooks/invoice/useMarkInvoiceAsPaid';

const MarkInvoiceAsPaid = ({
  tooltipTitle,
  placement,
  invoiceId,
  onMarkInvoiceAsPaid,
  isUnpaid = false,
}) => {
  const { loading, markInvoiceAsPaid } = useMarkInvoiceAsPaid();
  const handleMarkInvoiceAsPaid = async () => {
    await markInvoiceAsPaid(invoiceId);
    onMarkInvoiceAsPaid?.();
  };
  if (isUnpaid === false) return null;
  return (
    <Popconfirm
      title="Mark Invoice As Paid"
      description="Are you sure to mark this invoice as paid?"
      okText="Yes"
      cancelText="No"
      onConfirm={handleMarkInvoiceAsPaid}
    >
      <Tooltip
        title={tooltipTitle || 'Mark Paid By Cheque'}
        placement={placement}
      >
        <Button loading={loading} icon={<i className="fa fa-money-check" />}>
        </Button>
      </Tooltip>
    </Popconfirm>
  );
};

MarkInvoiceAsPaid.propTypes = {
  tooltipTitle: PropTypes.string,
  placement: PropTypes.string,
  invoiceId: PropTypes.number.isRequired,
  onMarkInvoiceAsPaid: PropTypes.func,
  isUnpaid: PropTypes.bool,
};

export default MarkInvoiceAsPaid;
